import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  SET_USER,
  SET_PROD,
  SEND_DATA,
  HANDLE_DETAILS,
  SET_NAME
} from "../actions/action-types/cart-actions";

const initState = {
  addedItems: [],
  total: 0,
  quantity: 0,
  name: null,

  inititems: [],

  //inCart:0,
  loop: 0,
  state_name: "",
  detailItem: "",
};

const cartReducer = (state = initState, action) => {
  //INSIDE HOME COMPONENT
  if (action.type === ADD_TO_CART) {
    let addedItem = state.inititems.find(item => item.key === action.key);

    //let inCart=state.inCart

    //console.log("ghghghghg",inCart)

    //check if the action id exists in the addedItems
    let existed_item = state.addedItems.find(item => action.key === item.key);
    var tem = "";
    tem = addedItem.price;
    tem = tem.toString();
    tem = tem.replace(/ EOS/g, "");
    var tem2 = 0;
    tem2 = parseFloat(tem);

      //onst name = localStorage.getItem("cardgame_account");
      //let newName=state.state_name + name
      

    if (existed_item) {
      let addedItem2 = state.addedItems.find(item => action.key === item.key);

      if (addedItem.quantity < addedItem2.max_quantity) {
        addedItem.quantity += 1;
      } else {
        alert("You can not add more items item out of stock");
      }

      //addedItem.quantity += 1

      return {
        ...state,

        total: state.total + tem2
      };
    } else {
      if (addedItem.max_quantity > 0) {
        addedItem.quantity = 1;
        //calculating the total

        let newTotal = state.total + tem2;
        newTotal = Number(newTotal.toFixed(4));
        addedItem.inCart = 1;

        return {
          ...state,

          addedItems: [...state.addedItems, addedItem],

          total: newTotal,
      //    state_name:newName
          
        };
      }
    }
  }

  if (action.type === REMOVE_ITEM) {
    let itemToRemove = state.addedItems.find(item => action.key === item.key);
    let new_items = state.addedItems.filter(item => action.key !== item.key);

    var tem = "";
    tem = itemToRemove.price;
    tem = tem.toString();
    tem = tem.replace(/ EOS/g, "");
    var tem2 = 0;
    tem2 = parseFloat(tem);

    itemToRemove.inCart = 0;
    //calculating the total
    let newTotal = state.total - tem2 * itemToRemove.quantity;
    newTotal = Number(newTotal.toFixed(4));
    console.log(itemToRemove);
    return {
      ...state,
      addedItems: new_items,

      total: newTotal
    };
  }

  //INSIDE CART COMPONENT
  if (action.type === ADD_QUANTITY) {
    let addedItem = state.inititems.find(item => item.key === action.key);
    {
      let addedItem2 = state.inititems.find(item => item.key === action.key);
      var tem = "";
      tem = addedItem.price;
      tem = tem.toString();
      tem = tem.replace(/ EOS/g, "");
      var tem2 = 0;
      tem2 = parseFloat(tem);
      if (addedItem.quantity < addedItem2.max_quantity) {
        addedItem.quantity += 1;

        let newTotal = state.total + tem2;
        newTotal = Number(newTotal.toFixed(4));
        return {
          ...state,
          total: newTotal
        };
      } else {
        alert("You can not add more items item out of stock");
      }
    }
  }

  if (action.type === SUB_QUANTITY) {
    let addedItem = state.inititems.find(item => item.key === action.key);
    var tem = "";
    tem = addedItem.price;
    tem = tem.toString();
    tem = tem.replace(/ EOS/g, "");
    var tem2 = 0;
    tem2 = parseFloat(tem);

    //if the qt == 0 then it should be removed
    if (addedItem.quantity === 1) {
      let new_items = state.addedItems.filter(item => item.key !== action.key);
      addedItem.inCart = 0;
      let newTotal = state.total - tem2;
      newTotal = Number(newTotal.toFixed(4));
      return {
        ...state,
        addedItems: new_items,
        total: newTotal
      };
    } else {
      addedItem.quantity -= 1;
      let newTotal = state.total - tem2;
      newTotal = Number(newTotal.toFixed(4));
      return {
        ...state,
        total: newTotal
      };
    }
  }

  if (action.type === SET_USER) {
    return Object.assign({}, state, {
      name: typeof action.name === "undefined" ? state.name : action.name
    });
  }

  if (action.type === SET_PROD) {
    let new_items = action.itemr;
    let existed_item = state.inititems.find(
      item => action.itemr.key === item.key
    );

    if (existed_item) {
    } else {
      if (new_items.max_quantity > 0) {
        return {
          ...state,
          inititems: [...state.inititems, new_items]
        };
      }
    }
  }

  if (action.type === SEND_DATA) {
         console.log("data sent success")
    //   let dataToSend=  state.addedItems.map(item=>{
    //     console.log("key",item.key)
    //     console.log("name",item.p_name)
    //     console.log("quantity",item.quantity)
    // })
 
}

  if (action.type === HANDLE_DETAILS) {
    console.log("HI DETAILS")
    let detailItem = state.inititems.find(item => item.key === action.key);
    console.log(" wala rola", detailItem);

    // let existed_item = state.detailItem.find(item => action.key === item.key);
    
    // if (existed_item) {

    //   return {
    //     ...state,
    //   };
    // }

    return {
      ...state,

     detailItem: [detailItem]
     
    };
   }

  if (action.type === SET_NAME) {
     console.log("HI SETNAME")

  }

  return state;
};
export default cartReducer;
